import React from 'react'

const badgeStyle = { position: 'relative' }
const Badge = ({count, className}) => (
  count ? <span style={badgeStyle} className={className}><span className='badge-notification ncss-brand circle'>{count}</span></span> : null
)

export default Badge



// WEBPACK FOOTER //
// ./client/src/components/Badge.js